import { OccurrenceItem, OccurrenceFilter } from './occurrences.types';
import api from '../../utils/api';

export class OccurrencesController {
  /**
   * Busca a lista de ocorrências de produção do servidor.
   */
  static async fetchOccurrences(): Promise<OccurrenceItem[]> {
    try {
      const response = await api.get<{ success: boolean; data: any[] }>('/occurrences');
      
      if (response.data && response.data.success && Array.isArray(response.data.data)) {
        return response.data.data.map((item: any) => {
          // Trata tanto chaves em camelCase (após interceptor Axios) quanto em snake_case (original)
          const orderNumber = item.orderNumber !== undefined ? item.orderNumber : item.order_number;
          const itemIndex = item.itemIndex !== undefined ? item.itemIndex : item.item_index;
          const productName = item.productName || item.product_name || 'Coifa';
          const currentOperator = item.currentOperator || item.current_operator || 'Operador';
          const allCollaborators = item.allCollaborators || item.all_collaborators || currentOperator;
          const createdAt = item.createdAt || item.created_at;

          return {
            id: Number(item.id),
            orderNumber: String(orderNumber || ''),
            itemIndex: Number(itemIndex || 0),
            productName: String(productName || ''),
            sector: String(item.sector || 'Geral'),
            occurrences: String(item.occurrences || ''),
            currentOperator: String(currentOperator),
            allCollaborators: String(allCollaborators),
            createdAt: String(createdAt || '')
          };
        });
      }
      return [];
    } catch (err) {
      console.error('Erro ao buscar ocorrências de produção:', err);
      throw err;
    }
  }
}
